module.exports = __webpack_public_path__ + "img/7812cf2.png";